import React from 'react';
import PropTypes from 'prop-types';

import { propTypes as i18nPropTypes } from '../../../../../hocs/intlEquipped';
import formatAddress from '../../../../../util/formatAddress';
import { deliveryPropType } from '../../../../../types/delivery';

import Alert, { severityTypes } from '../../../../Alert';
import Icon from '../../../../Icon';
import DetailsHeader from '../DetailsHeader';
import DetailInlineSection from '../DetailInlineSection';
import { OutlinedButton } from '../../../../Buttons';

const deliveryDetailsData = (delivery, formatMessage, formatWeekDays) => [
    {
        detail: formatWeekDays(delivery.days),
        title: formatMessage('subscription.deliverySection.days'),
        iconName: 'mailbox',
    },
    {
        detail: formatAddress({ address: delivery.address }),
        title: formatMessage('subscription.deliverySection.address'),
        iconName: 'delivery-pin',
    },
];

const DeliveryDetails = ({
    theme,
    delivery,
    fetchDeliveries,
    fetching = false,
    i18n: {
        formatMessage,
        formatWeekDays,
    },
}) => {
    const deliveryDetails = deliveryDetailsData(delivery, formatMessage, formatWeekDays);

    return (
        <div className={ theme.deliveryDetailsContent } data-testid="deliveryDetails">
            <DetailsHeader text={ formatMessage('subscription.deliverySection.header') } />
            <div>
                {delivery.success
                    ? deliveryDetails.map(({
                        iconName,
                        title,
                        detail,
                    }) => (
                        <DetailInlineSection
                            key={ detail }
                            title={ title }
                            detail={ detail }
                            detailClass={ theme.deliveryDetail }
                            icon={{
                                component: (
                                    <span className={ theme.deliveryIcon }>
                                        <Icon name={ iconName } />
                                    </span>
                                ),
                            }}
                            theme={ theme }
                        />
                    )) : (
                        <Alert
                            severity={ severityTypes.ERROR }
                            testId="errorFetchingDeliveryDetails"
                        >
                            {formatMessage('subscription.deliverySection.errors.cannotFetchDelivery')}
                            <div className={ theme.retryButton }>
                                <OutlinedButton
                                    onClick={ fetchDeliveries }
                                    disabled={ fetching }
                                    icon={ fetching
                                        ? {
                                            component: () => <Icon theme={ theme } name="loading" />,
                                            position: 'left',
                                        }
                                        : {} }
                                >
                                    {formatMessage('subscription.deliverySection.buttons.retry')}
                                </OutlinedButton>
                            </div>
                        </Alert>
                    )}
            </div>
        </div>
    );
};

DeliveryDetails.propTypes = {
    theme: PropTypes.shape({}),
    delivery: deliveryPropType.isRequired,
    fetchDeliveries: PropTypes.func.isRequired,
    fetching: PropTypes.bool,
    i18n: i18nPropTypes,
};

export default DeliveryDetails;
